import React, { useState, useEffect } from 'react'
import { Dropdown } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { apiHandler } from '../../api/apihandler';
import { MADE_IT_COMMENT_LIKE, MADE_IT_COMMENT_LIKES } from "../../api/constants";
import MadeItCommentBox from './madeItCommentBox'


const SingleUserMadeItComment = ({ madeItId, commentElm, setRefreshCommentList, depth = 0, onCommentAdded }) => {
    const navigate = useNavigate();
    const [showCommentBox, setShowCommentBox] = useState(false);
    const [showLikesList, setShowLikesList] = useState(false);
    const [commentLikesUserList, setCommentLikesUserList] = useState([]);
    const [isLike, setIsLike] = useState(commentElm?.is_like === 1);
    const [likeCount, setLikeCount] = useState(commentElm?.like_count || 0);

    useEffect(() => {
        getCommentLikesUserList(commentElm?.id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    async function getCommentLike(commentId) {
        if (!localStorage.getItem("uzoneAuthToken")) {
            navigate('/auth/sign-in')
            return
        }
        const next = !isLike
        const nextCount = next ? likeCount + 1 : likeCount - 1
        setIsLike(next)
        setLikeCount(nextCount)
        try {
            await apiHandler(MADE_IT_COMMENT_LIKE, "POST", { comment_id: commentId })
            getCommentLikesUserList(commentId)
        } catch (error) {
            console.error(error);
            setIsLike(!next)
            setLikeCount(likeCount)
        }
    }

    async function getCommentLikesUserList(commentId) {
        try {
            const res = await apiHandler(MADE_IT_COMMENT_LIKES, "POST", { comment_id: commentId })
            if (res.data?.response?.status === 200) {
                setCommentLikesUserList(res?.data?.data?.userLikes ?? [])
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div className="d-flex justify-content-between" style={{ marginTop: "10px" }}>
            <div className="me-3">
                <img loading="lazy" className="rounded-circle avatar-30"
                    src={commentElm?.user?.user_setting?.photo ? commentElm?.user?.user_setting?.photo : "https://uzone360live.s3.amazonaws.com/noimage.png"} alt="" />
            </div>
            <div className="w-100">
                <div className="d-flex justify-content-between flex-wrap">
                    <div>
                        <h6 className="mb-0 d-inline-block"><Link to="#">{commentElm?.user?.first_name + " " + commentElm?.user?.last_name}</Link></h6>
                        {
                            commentElm?.image ?
                                <div>
                                    <img loading="lazy" className="avatar-60" src={commentElm?.image} alt="" />
                                </div> : null
                        }
                        <p className="mb-0">{commentElm?.comment}</p>
                        <div>
                            <h6 className="mb-0 d-inline-block"
                                onClick={() => { getCommentLike(commentElm?.id) }}
                                onMouseEnter={() => setShowLikesList(true)}
                                onMouseLeave={() => setShowLikesList(false)}
                            >
                                <span className={`material-symbols-outlined nmha-inline-like-icon${isLike ? ' filled liked' : ''}`}>favorite</span>
                                <Link to="#" style={{ marginLeft: "6px" }}>{likeCount} Like</Link>
                            </h6>
                            <h6 className="mb-0 d-inline-block" style={{ marginLeft: "10px" }}>
                                {depth < 3 ? (
                                    <Link to="#" onClick={() => { setShowCommentBox((val) => !val) }}>Reply</Link>
                                ) : null}
                            </h6>
                        </div>

                        {
                            showLikesList && commentLikesUserList?.length > 0 ?
                                <div className="card-header-toolbar d-flex align-items-center" style={{ position: "absolute" }}
                                    onMouseEnter={() => setShowLikesList(true)}
                                    onMouseLeave={() => setShowLikesList(false)}>
                                    <Dropdown show>
                                        <Dropdown.Menu>
                                            {commentLikesUserList.map((elm) => (
                                                <Dropdown.Item key={elm?.id} href={`/dashboard/app/friend-profile/${elm?.user?.slug}`}>
                                                    {elm?.user?.first_name + " " + elm?.user?.last_name}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div> : null
                        }

                        {
                            showCommentBox ?
                                <MadeItCommentBox
                                    madeItId={madeItId}
                                    commentId={commentElm?.id}
                                    setRefreshCommentList={setRefreshCommentList}
                                    setShowCommentBox={setShowCommentBox}
                                    onCommentAdded={onCommentAdded} /> : null
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SingleUserMadeItComment
